import { Ajax } from '../classes/ajax.js';

export function emptyCart() {
    return new Ajax(
        'POST_WORDPRESS',
        NOJESRESOR_WORDPRESS.ajaxurl + '/empty_cart',
        {
            security: application.nonce,
            action: 'nch_empty_cart',
        },
    );
}
